import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ title, selectedCount }) => {
  if (title === 'mass') {
    return (
      <div className="text-center">
        Are you sure you want to delete
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected updates?
      </div>
    );
  }

  if (title === 'single') {
    return (
      <div className="text-center">
        Are you sure you want to delete the update?
      </div>
    );
  }

  return null;
};

Body.propTypes = {
  title: PropTypes.string,
  selectedCount: PropTypes.number,
};

export default Body;
